import { render } from "./VirtualTable.vue?vue&type=template&id=3e725eb4&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"

import "./VirtualTable.vue?vue&type=style&index=0&id=3e725eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e725eb4"]])

export default __exports__